/**
 * This code imports the createSlice function from the '@reduxjs/toolkit' library.
 * It also initializes the initial state of the modelsSlice object with default
 * values for various properties.
 * The createSlice function is used to create a Redux slice with the name 'models'
 * and a set of reducer functions.
 * These reducer functions are used to update the state of the modelsSlice object
 * based on dispatched actions.
 * The setScreens, setCanopy, setSpeakers, setQuestions, and setSelectedId functions
 * are exported as actions.
 * The modelsSlice reducer is exported as the default export of this module.
 */

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  step: 1,
  speakerOption: 1,
  screens: 1,
  canopy: false,
  canopyScreens: 0,
  speakers: false,
  questions: 1,
  selectedId: 0,
  arStarted: false,
  speakerPostnDrivethru: false,
  driveThru: false
}

export const modelsSlice = createSlice({
  name: 'models',
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload
    },
    setSpeakerOption: (state, action) => {
      state.speakerOption = action.payload
    },
    setScreens: (state, action) => {
      state.screens = action.payload
    },
    setCanopy: (state, action) => {
      state.canopy = action.payload
    },
    setSpeakers: (state, action) => {
      state.speakers = action.payload
    },
    setQuestions: (state, action) => {
      state.questions = action.payload
    },
    setSelectedId: (state, action) => {
      state.selectedId = action.payload
    },
    setARStarted: (state, action) => {
      state.arStarted = action.payload
    },
    setSpeakerPostnDrivethru: (state, action) => {
      state.speakerPostnDrivethru = action.payload
    },
    setDriveThru: (state, action) => {
      state.driveThru = action.payload
    }
  }
})

export const {
  setStep,
  setSpeakerOption,
  setScreens,
  setCanopy,
  setSpeakers,
  setQuestions,
  setSelectedId,
  setARStarted,
  setSpeakerPostnDrivethru,
  setDriveThru
} = modelsSlice.actions

export default modelsSlice.reducer
